import React from 'react';
import FLAGS from '../data/flags';

export default function FlagIcon({ code, size = '1.2em' }) {
  const iso = FLAGS[code];
  if (!iso) return <span style={{ fontSize: size }}>🌍</span>;
  return (
    <span
      className={`fi fi-${iso}`}
      style={{ fontSize: size, borderRadius: '2px', flexShrink: 0 }}
    />
  );
}
